import { I18nFragment } from '@diagentech/exprworks-ui-components';
import Link from '@mui/material/Link';
import React, { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '@/App/hooks';
import { TERMS_OF_USE_DIALOG_ID } from '@/components/termsOfUse/TermsOfUseDialog';
import { selectAppConfig } from '@/features/config/selectAppConfig';
import { setShowTermsOfUse } from '@/features/ui/uiSlice';

export const TermsOfUseLink: React.FC = () => {
  const dispatch = useAppDispatch();
  const { termsOfUseEnabled } = useAppSelector(selectAppConfig);

  const showTermsOfUse = useCallback(() => {
    dispatch(setShowTermsOfUse(true));
  }, [dispatch]);

  if (!termsOfUseEnabled) {
    return null;
  }

  return (
    <Link
      variant="body2"
      component="button"
      aria-controls={TERMS_OF_USE_DIALOG_ID}
      aria-haspopup="true"
      onClick={showTermsOfUse}
    >
      <I18nFragment id="SH.PG.TERMSOFUSE" />
    </Link>
  );
};
